export enum SearchEntityTypeEnum {
    Unknown,
    Intermediary,
    SalesPerson,
}
